import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { fmtEuro, MONTHS } from './paymentsShared';

// data: array 12 valori (NETTO incassato per mese) | null
export const IncomeTrend = ({ data, year }) => {
  if (!data) {
    return (
      <Card className="card-abitalo" data-testid="income-trend">
        <CardHeader className="pb-2"><CardTitle className="text-base font-bold">Andamento incassi</CardTitle></CardHeader>
        <CardContent>
          <p className="text-sm text-[#737373]">Seleziona un anno specifico per vedere l'andamento mensile.</p>
        </CardContent>
      </Card>
    );
  }
  const max = Math.max(1, ...data);
  const total = data.reduce((s, v) => s + v, 0);
  return (
    <Card className="card-abitalo" data-testid="income-trend">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-bold">Andamento incassi {year} <span className="text-[11px] font-normal text-[#a3a3a3]">· netto IVA</span></CardTitle>
          <span className="text-sm font-semibold text-emerald-600" data-testid="income-trend-total">Totale netto {fmtEuro(total)}</span>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex items-end gap-2 h-40">
          {data.map((v, i) => (
            <div key={i} className="flex-1 flex flex-col items-center gap-1" data-testid={`income-month-${i}`} title={`${MONTHS[i]}: ${fmtEuro(v)}`}>
              <div className="w-full flex items-end justify-center" style={{ height: '120px' }}>
                <div className="w-full max-w-[26px] bg-emerald-500 rounded-t transition-all" style={{ height: `${(v / max) * 120}px` }} />
              </div>
              <div className="text-[10px] text-[#737373]">{MONTHS[i]}</div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default IncomeTrend;
